import { PageDevice } from '../../constants/Device';

export const DisplayMode = {
  ON: 'on',
  OFF: 'off'
} as const;
export type DisplayMode = (typeof DisplayMode)[keyof typeof DisplayMode];

export const ChannelId = {
  NNN: 'nnn',
  JNN: 'jnn'
} as const;
export type ChannelId = (typeof ChannelId)[keyof typeof ChannelId];

/**
 * @param channel
 */
export function fromString(channel: string): ChannelId | undefined {
  switch (channel) {
    case ChannelId.NNN:
      return ChannelId.NNN;
    case ChannelId.JNN:
      return ChannelId.JNN;
  }
  return undefined;
}

export const ChannelStatus = {
  ON: 'on',
  OFF: 'off',
  MAINTENANCE: 'maintenance',
  TROUBLE: 'trouble'
} as const;
export type ChannelStatus = (typeof ChannelStatus)[keyof typeof ChannelStatus];

export const Device = {
  PC: 'pc',
  TABLET: 'tablet',
  SP: 'sp'
} as const;
export type Device = (typeof Device)[keyof typeof Device];

export const OS = {
  IOS: 'ios',
  ANDROID: 'android'
} as const;
export type OS = (typeof OS)[keyof typeof OS];

export interface IChannelDataResponse {
  readonly id: ChannelId;
  readonly status: ChannelStatus;
}
export interface IChannelData {
  readonly id: ChannelId;
  readonly name: string;
  readonly status: ChannelStatus;
  readonly plist: string;
  readonly poster: string;
  readonly device?: Device;
  readonly countryCode: string;
  readonly os?: OS;
  readonly channelInfo?: {
    readonly previousId: ChannelId;
    readonly nextId: ChannelId;
    readonly slideNumber: number;
    readonly showPreviousArrow: boolean;
    readonly showNextArrow: boolean;
  };
}

export interface ILiveStreamResponse {
  readonly title: string;
  readonly displayMode: DisplayMode;
  readonly channels: {
    nnn: IChannelDataResponse;
    jnn: IChannelDataResponse;
  };
}

export interface ILiveStream {
  readonly title: string;
  readonly displayMode: DisplayMode;
  readonly channels: {
    nnn: IChannelData;
    jnn: IChannelData;
  };
}

export interface ILiveStreamInformation {
  readonly isShowBreakingModule: boolean;
  readonly displayMode: DisplayMode;
  readonly title?: string;
  readonly channel?: ChannelId;
  readonly startTime?: Date;
  readonly endTime?: Date;
  readonly url?: string;
}

export interface ILiveTimeTable {
  readonly channel: {
    nnn: {
      info: {
        time: string;
        title: string;
      }[];
      text: string;
    };
    jnn: {
      info: {
        time: string;
        title: string;
      }[];
      text: string;
    };
  };
}

export default interface ILiveStreamRepository {
  get(device: PageDevice): Promise<ILiveStreamResponse | null>;
  getLiveStreamInformation(): Promise<ILiveStreamInformation | null>;
}
